import { trainersApi } from "api";
import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TrainerGroupForm, TrainerGroupFormValues } from "./TrainerGroupForm/TrainerGroupForm";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PageMain } from "components/molecules";
import { useToaster } from "utils";
import { useQueryClient } from "@tanstack/react-query";

export const TrainerGroupAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { showSuccess } = useToaster();

  const onSubmit = async (data: TrainerGroupFormValues) => {
    try {
      await trainersApi.createGroup(data);
      navigate(routes.TRAINERS_GROUPS);
      showSuccess("Grupa trenerów została dodana");
      queryClient.invalidateQueries({
        queryKey: ["trainerGroups"],
      });
    } catch (e) {
      console.error(e);
      showSuccess("Wystąpił błąd podczas dodawania grupy trenerów");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Trenerzy", path: routes.TRAINERS },
          { title: "Grupy trenerów", path: routes.TRAINERS_GROUPS },
          { title: "Tworzenie nowej grupy" },
        ]}
        headerText="Dodaj nową grupę"
      />
      <TrainerGroupForm onSubmit={onSubmit} />
    </PageMain>
  );
};
